module.exports = __webpack_public_path__ + "static/media/halina.0cab973d.jpg";